import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/styles/index.scss";
import Toasted from "vue-toasted";
import i18n from "@/locales"; // Internationalization
Vue.use(Toasted);

// widget setup
// (optional) 'Custom elements polyfill'
import "document-register-element/build/document-register-element";
// vue-custom-element by karol-f
import vueCustomElement from "vue-custom-element";
Vue.use(vueCustomElement);
Vue.directive("click-outside", {
  bind: function(el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== "function") {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) {
        warn += `Found in component '${compName}'`;
      }

      console.warn(warn);
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;

    // add Event Listeners
    document.addEventListener("click", handler);
  },

  unbind: function(el) {
    // Remove Event Listeners
    document.removeEventListener("click", el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  },
});
Vue.config.productionTip = false;

// new Vue is not needed anymore, as you're initializing the app through vue-custom-element
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

// use vue-custom-element
App.store = store;
App.router = router;
App.i18n = i18n;
Vue.customElement("vue-widget", App);
